export const oseIconAlts = [
  'group',
  'notebook',
  'class',
  'turnandtalk',
  'self',
  'partner',
  'exit',
  'circle',
  'home',
  'safety',
]
